<div class="md-form md-outline mb-0 mt-3">
  <textarea [ngModel]="userId.email" (ngModelChange)="onEmail($event)" id="form-email" class="form-control textarea form-{{color}}" rows="1" type="email" mdbInput style="resize:none;"></textarea>
  <label for="form-email">{{ 'EMAIL' | translate }}</label>
  <small id="form-email-help" class="form-text text-muted d-flex align-items-center">
    <i *ngIf="userId.isValid('email')" class="{{color}}-text fas fa-check-circle pr-1"></i>
    <i *ngIf="!userId.isValid('email')" class="text-warning fas fa-times-circle pr-1"></i>
    <span class="mr-auto">{{userId.email.length}}/{{userId.requirement('email').maxLength}} ({{ 'MINIMUM' | translate }}: {{userId.requirement('email').minLength}})</span>
  </small>
</div>